import Form from './SurgeryForm';
import React, { Component } from 'react';
import LoadMask from 'Utils/LoadMask/LoadMask';
export default class SurgeryCrear extends Component {

    state = {
        editar: false,
        mensaje: 'Agregar cita',
        search_patient: 1,
        no_patient_options: 1,
        load_products: true,
    }

    componentWillMount(){

        const {
            createInitialize,
        } = this.props;

        createInitialize();

        if(this.props.match.params.id){
            this.props.detail(this.props.match.params.id);
            this.setState({
                    editar: true,
                    mensaje: 'Editar Cita'
                });
        }else{
            this.props.limpiarProductosCirugia();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(prevProps.updateData.patient_id != this.props.updateData.patient_id){
            if(this.props.updateData.patient_id){
                this.setState({
                    search_patient: 0,
                    no_patient_options: 0,
                });
            }
        }
    }

    initializePatientBirthdate = () => {

        const {
            createInitializePatient
        } = this.props;

        this.setState({
            search_patient: !this.state.search_patient,
        })

        createInitializePatient();
    }

    showPatientOptions = () => {
        this.props.toggleModalServicios(false);
        this.setState({
            no_patient_options: !this.state.no_patient_options,
        })
    }

    showPatientSearch = () => {
        this.setState({
            search_patient: !this.state.search_patient,
        })
    }

    showProducts = () => {
        this.setState({
            load_products: !this.state.load_products,
        })
    }

    render() {

        const {
            create,
            update,
            detailPatient,
            services_list,
            is_surgery
        } = this.props;

        const {
            municipios,
            updateData,
            setUpdateData,
            cargando,
        } = this.props;

        return (
            <div className="content-with-tabs">
                <div className="d-inline-flex w-100">
                    <div className="row-fluid w-50 tab-background-blue">
                        <a href="/#/surgeries" className="d-flex justify-content-center align-items-center tab-active tab-br-tr">
                            CITAS DE HOY
                        </a>
                    </div>
                    <div className="row-fluid w-50 tab-background">
                        <a href="/#/surgeries-schedule" className="d-flex justify-content-center align-items-center tab tab-br-bl">
                            AGENDA
                        </a>
                    </div>
                </div>
                <div className="mx-5 my-4">
                    <div className="table-decoration">
                        <LoadMask loading={cargando} blur_1>
                            {
                                this.state.editar ?
                                    <div className="fields">
                                        <div className="top-title">
                                            CITA
                                        </div>
                                        <Form
                                            editando={true}
                                            onSubmit={update}
                                            updateData={updateData}
                                            setUpdateData={setUpdateData}
                                            municipios={municipios}
                                            detailPatient={detailPatient}

                                            patient_exists={this.state.patient_exists}
                                            search_patient={this.state.search_patient}
                                            showPatientSearch={this.showPatientSearch}
                                            showPatientOptions={this.showPatientOptions}
                                            no_patient_options={this.state.no_patient_options}
                                            initializePatientBirthdate={this.initializePatientBirthdate}

                                            showProducts={this.showProducts}
                                            load_products={this.state.load_products}
                                            services_list={services_list}

                                            listarServicios={this.props.listarServicios}
                                            addServiceToList={this.props.addServiceToList}
                                            data_service={this.props.data_service}
                                            page_service={this.props.page_service}
                                            cargando_services={this.props.cargando_services}
                                            modal_service={this.props.modal_service}
                                            removeServiceToList={this.props.removeServiceToList}
                                            upDownCant={this.props.upDownCant}
                                            surgery_id={this.props.match.params.id}

                                            searchService={this.props.searchService}
                                            buscador_service={this.props.buscador_service}
                                            addServiceToListDiff={this.props.addServiceToListDiff}

                                            setReferentCategory={this.props.setReferentCategory}

                                            setCant={this.props.setCant}
                                            setCantInSurgery={this.props.setCantInSurgery}
                                            is_surgery={is_surgery}
                                        />
                                    </div>
                            :
                                <div className="fields">
                                    <div className="top-title">
                                        NUEVA CITA
                                    </div>
                                    <Form
                                        onSubmit={create}

                                        municipios={municipios}
                                        detailPatient={detailPatient}

                                        patient_exists={this.state.patient_exists}
                                        search_patient={this.state.search_patient}
                                        showPatientSearch={this.showPatientSearch}
                                        showPatientOptions={this.showPatientOptions}
                                        no_patient_options={this.state.no_patient_options}
                                        initializePatientBirthdate={this.initializePatientBirthdate}

                                        showProducts={this.showProducts}
                                        load_products={this.state.load_products}
                                        services_list={services_list}

                                        listarServicios={this.props.listarServicios}
                                        addServiceToList={this.props.addServiceToList}
                                        data_service={this.props.data_service}
                                        page_service={this.props.page_service}
                                        cargando_services={this.props.cargando_services}
                                        modal_service={this.props.modal_service}
                                        removeServiceToList={this.props.removeServiceToList}

                                        searchService={this.props.searchService}
                                        buscador_service={this.props.buscador_service}

                                        addServiceToListDiff={this.props.addServiceToListDiff}
                                        upDownCant={this.props.upDownCant}

                                        setReferentCategory={this.props.setReferentCategory}

                                        setCant={this.props.setCant}
                                        setCantInSurgery={this.props.setCantInSurgery}
                                        is_surgery={is_surgery}
                                    />
                                </div>
                            }
                        </LoadMask>
                    </div>
                </div>
            </div>
        )
    }
}
